import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Button, Container, Box, Typography, Card, CardContent, TextField, Grid, Paper } from '@mui/material';
import MessageIcon from '@mui/icons-material/Message';
import Avatar from '@mui/material/Avatar';
import { BsTelephoneFill } from 'react-icons/bs';
import LeadService from '../core/services/leadsService';
import { MdEmail } from 'react-icons/md';
import logo_between from '../../public/assets/logo_between.png';
import logo_white from '../../public/assets/logo-white.jpeg';
import user_icon from '../../public/assets/user_icon.jpg';
import { BsJustify } from 'react-icons/bs';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import LinearProgress from '@mui/material/LinearProgress';
import { format } from 'date-fns';
import PhoneIcon from '@mui/icons-material/Phone';
import PropertyIcon from '../../public/assets/PropertyIcon.svg';
import originMap from '../../public/assets/OriginMap.svg';
import destinationMap from '../../public/assets/destinationMap.svg';
import Divider from '@mui/material/Divider';
import ScrollAnimation from 'react-animate-on-scroll';
import { styled } from '@mui/material/styles';
import { GoogleMap, DirectionsService, DirectionsRenderer, useLoadScript, Marker, OverlayView } from '@react-google-maps/api';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));
const useStyles = makeStyles((theme) => ({
    googleApisImageStyle: {
        width: '1261px',
        height: '470px',
        borderRadius: '10px',
        [theme.breakpoints.down('md')]: {
            width: '1020px',
            height: '470px',
            borderRadius: '10px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1100px',
            height: '470px',
            borderRadius: '10px',
        },
        [theme.breakpoints.up('lg')]: {
            width: '100%',
            height: '570px',
            borderRadius: '10px',
        },
    },
}));
const AdminLeadsDetails = () => {
    let { id } = useParams();
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [LeadDetails, setLeadDetails] = useState(null);
    const [jobData, setJobData] = useState(null);
    const [customerData, setCustomerData] = useState(null);
    const [assigntoData, setAssigntoData] = useState(null);
    const [origin, setOrigin] = useState(); //Customer
    const [origin2, setOrigin2] = useState(); //Agent or AssignTo
    const [destination, setDestination] = useState(); // Lead
    const [angle, setAngle] = useState(0);
    const [angle2, setAngle2] = useState(0);
    const [directions, setDirections] = useState(null);
    const [directions2, setDirections2] = useState(null);
    const [phoneNumber1, setPhoneNumber1] = useState('');
    const [phoneNumber2, setPhoneNumber2] = useState('');
    const [duration, setDuration] = useState(null);
    const [distance, setDistance] = useState(null);
    const [distance2, setDistance2] = useState(null);
    const [duration2, setDuration2] = useState(null);
    const [showAllReplies, setShowAllReplies] = React.useState(false);
    const [displayNotes, setDisplayNotes] = useState([]);
    const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);
    const { UserType, UserId, RouteType, AlertView } = location.state || {};
    const viewMode = location.state?.viewMode || 'list';
    const preprocessDateString = (dateString) => {
        // Remove GMT suffix and ensure the string is in a standard ISO format
        if (dateString.endsWith('GMT')) {
            return dateString.replace('GMT', 'Z'); // Replace GMT with Z for UTC
        }
        return dateString;
    };

    const adjustTimeBasedOnOffsetForNotes = (dateString, offsetInHours) => {
        // Preprocess the date string
        const processedDateString = preprocessDateString(dateString);

        // Parse the date string to a Date object
        const date = new Date(processedDateString);

        // Convert the date to UTC by adjusting for the local timezone offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset (in hours)
        const adjustedDate = new Date(utcDate.getTime() + offsetInHours * 3600 * 1000);

        return adjustedDate;
    };

    const formatDateTimeForNotes = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hour}:${minute}`;
    };

    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true, // Use 12-hour format with AM/PM
        };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const userOffset = getUserOffset();
    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(LeadDetails?.created_at, userOffset);
    const formattedDate = adjustedDate ? formatDateTime(adjustedDate) : 'No date available';

    const combineDateTime = (date, time) => {
        if (!date || !time) {
            return null;
        }
        return `${date}T${time}Z`;
    };

    const combinedDateTimeString = combineDateTime(LeadDetails?.date, LeadDetails?.time);
    const adjustedDateLeads = combinedDateTimeString ? adjustTimeBasedOnOffsetForReceivedData(combinedDateTimeString, userOffset) : null;
    const formattedDateLeads = adjustedDateLeads ? formatDateTime(adjustedDateLeads) : 'No date available';

    const imageStyle = {
        width: '80px',
        height: '70px',
        marginTop: '-42px',
        transform: `rotate(${angle}deg)`,
    };
    const imageStyle2 = {
        width: '80px',
        height: '56px',
        marginTop: '-42px',
        transform: `rotate(${angle2}deg)`,
    };
    const GetAllLeads = useCallback(
        async (isFirstCall) => {
            try {
                if (isFirstCall) {
                    setIsLoadingDetails(true);
                }
                const res = await LeadService.leadDetailsByAdmin(id);
                if (res?.data?.success) {
                    setIsLoadingDetails(false);
                    setLeadDetails(res?.data.lead);
                    setJobData(res?.data?.lead);
                    setCustomerData(res?.data?.lead?.customer);
                    setAssigntoData(res?.data?.lead?.assignto);
                    return;
                }
            } catch (error) {
                toast.error(error.message);
                console.error(error);
            }
        },
        [id]
    );
    // const GetAllLeads = async (id) => {

    //     try {
    //         setIsLoadingDetails(true);
    //         const res = await LeadService.leadDetailsByAdmin(id);
    //         setIsLoadingDetails(false);
    //         if (res?.data?.success) {
    //             setLeadDetails(res?.data.lead);
    //             setJobData(res?.data?.lead);
    //             setCustomerData(res?.data?.lead?.customer);
    //             setAssigntoData(res?.data?.lead?.assignto);
    //             return;
    //         }
    //     } catch (error) {
    //         toast.error(error.message)
    //         console.error(error);
    //     }
    // }
    // useEffect(() => {
    //     GetAllLeads(id);
    // }, []);

    useEffect(() => {
        GetAllLeads(isFirstCallRef.current);
        isFirstCallRef.current = false;

        intervalRef.current = setInterval(() => {
            GetAllLeads(false);
        }, 10000);

        return () => clearInterval(intervalRef.current);
    }, [GetAllLeads]);

    const handleButtonViewNumber1 = () => {
        if (customerData?.phone === null || customerData?.phone === undefined || customerData?.phone === '') {
            return toast.error('Phone number is not available.');
        } else {
            setPhoneNumber1(customerData?.phone);
        }
    };

    const handleButtonViewNumber2 = () => {
        if (assigntoData?.phone === null || assigntoData?.phone === undefined || assigntoData?.phone === '') {
            return toast.error('Phone number is not available.');
        } else {
            setPhoneNumber2(assigntoData?.phone);
        }
    };

    const mapContainerStyle = {
        width: 'auto',
        height: '450px',
        marginTop: '20px',
        marginBottom: '20px',
        borderRadius: '20px',
    };

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyCkMAzfTYAjsRE0zZoITa3ktRqd00zLksU',
        libraries: ['directions'],
    });

    const prevOriginRef = useRef();
    const prevOrigin2Ref = useRef();
    const prevDestinationRef = useRef();
    const intervalRef = useRef(null);
    const isFirstCallRef = useRef(true);
    const mapRef = useRef();

    useEffect(() => {
        if (assigntoData) {
            const newOrigin2 = {
                lat: parseFloat(assigntoData?.latitude),
                lng: parseFloat(assigntoData?.longitude),
            };
            if (!prevOrigin2Ref.current || newOrigin2.lat !== prevOrigin2Ref.current.lat || newOrigin2.lng !== prevOrigin2Ref.current.lng) {
                setOrigin2(newOrigin2);
                setAngle2(assigntoData.angle);
                prevOrigin2Ref.current = newOrigin2;
            }
        }
    }, [assigntoData]);

    useEffect(() => {
        if (jobData) {
            // Check if meeting latitude and longitude are available
            let latitude = jobData?.meeting_latitude;
            let longitude = jobData?.meeting_longitude;

            // If not available, use buyer latitude and longitude
            if (!latitude || !longitude) {
                latitude = jobData?.buyer_latitude;
                longitude = jobData?.buyer_longitude;
            }

            // Create the new destination object
            const newDestination = {
                lat: parseFloat(latitude),
                lng: parseFloat(longitude),
            };

            // Update destination only if it has changed
            if (
                !prevDestinationRef.current ||
                newDestination.lat !== prevDestinationRef.current.lat ||
                newDestination.lng !== prevDestinationRef.current.lng
            ) {
                setDestination(newDestination);
                prevDestinationRef.current = newDestination;
            }
        }
    }, [jobData]);

    useEffect(() => {
        if (customerData && jobData) {
            let newOrigin = {
                lat: parseFloat(customerData?.latitude),
                lng: parseFloat(customerData?.longitude),
            };

            // Check if customer latitude or longitude is missing
            if (!newOrigin.lat || !newOrigin.lng) {
                // If missing, use destination latitude and longitude as customer location
                newOrigin = {
                    lat: destination?.lat,
                    lng: destination?.lng,
                };
            }

            // Update origin if it has changed
            if (!prevOriginRef.current || newOrigin.lat !== prevOriginRef.current.lat || newOrigin.lng !== prevOriginRef.current.lng) {
                setOrigin(newOrigin);
                setAngle(customerData.angle);
                prevOriginRef.current = newOrigin;
            }
        }
    }, [customerData, jobData, destination]);

    useEffect(() => {
        const map = mapRef.current;
        if (map) {
            const bounds = new window.google.maps.LatLngBounds();

            // Extend bounds with the manual points (origin, origin2, destination)
            if (origin?.lat && origin?.lng) bounds.extend(new window.google.maps.LatLng(origin.lat, origin.lng));
            if (origin2?.lat && origin2?.lng) bounds.extend(new window.google.maps.LatLng(origin2.lat, origin2.lng));
            if (destination?.lat && destination?.lng) bounds.extend(new window.google.maps.LatLng(destination.lat, destination.lng));

            // Extend bounds with route paths if directions are available
            if (directions?.routes?.length) {
                directions.routes[0].overview_path.forEach((point) => bounds.extend(point));
            }
            if (directions2?.routes?.length) {
                directions2.routes[0].overview_path.forEach((point) => bounds.extend(point));
            }

            // Only fit bounds if there are valid points
            if (!bounds.isEmpty()) {
                map.fitBounds(bounds, { top: 50, bottom: 50, left: 50, right: 50 }); // Add padding to prevent excessive zoom
            }
        }
    }, [origin, origin2, destination, directions, directions2]); // Trigger when these points change

    useEffect(() => {
        if (isLoaded && origin2 && destination) {
            const directionsService = new window.google.maps.DirectionsService();
            const request2 = {
                origin: origin2,
                destination: destination,
                travelMode: 'DRIVING',
            };
            directionsService.route(request2, (response, status) => {
                if (status === 'OK') {
                    setDuration2(response.routes[0].legs[0].duration.text);
                    setDistance2(response.routes[0].legs[0].distance.text);
                    setDirections2(response);
                } else {
                    console.error('Error fetching directions:', status);
                }
            });
        }
    }, [isLoaded, origin2, destination]);

    useEffect(() => {
        if (isLoaded && origin && destination) {
            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: origin,
                destination: destination,
                travelMode: 'DRIVING',
            };
            directionsService.route(request, (response, status) => {
                if (status === 'OK') {
                    setDuration(response.routes[0].legs[0].duration.text);
                    setDistance(response.routes[0].legs[0].distance.text);
                    setDirections(response);
                } else {
                    console.error('Error fetching directions:', status);
                }
            });
        }
    }, [isLoaded, origin, destination]);

    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
        };
        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            follow_up: '#469990',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            follow_up: '1px solid #469990',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };
    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(LeadDetails?.status);

    const HandleBackNavigate = (id) => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        isFirstCallRef.current = true;
        if (UserType === 'isa_agent') {
            navigate(`/isa-agent-details/${UserId}`);
        } else if (UserType === 'agent') {
            navigate(`/agents-details/${UserId}`);
        } else if (RouteType === 'allJobRoutes') {
            navigate('/ViewAllJobRoutes');
        } else if (AlertView === 'Alerts_View') {
            navigate('/Admin-Alerts');
        } else {
            navigate('/admin-Leads', { state: { viewMode } });
        }
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    };
    const GetIcaLeadNotes = async (id) => {
        try {
            const res = await LeadService.GetLeadNote(id);
            if (res?.data?.success) {
                const formattedNotes = res?.data?.notes.map((note) => {
                    return {
                        id: note?.id,
                        content: note?.note,
                        creatorName: note?.creatorName,
                        createTime: note?.created_at,
                        replies: note?.replies || [],
                    };
                });
                setDisplayNotes(formattedNotes);
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };

    useEffect(() => {
        GetIcaLeadNotes(id);
    }, [id]);
    return isLoaded ? (
        <>
            <div style={{ marginBottom: '15px' }}> {isLoadingDetails && <LinearProgress />}</div>
            <Box>
                <Button
                    onClick={() => HandleBackNavigate(id)}
                    sx={{ background: '#efefef', marginLeft: '22px', padding: '6px', '&:hover': { background: '#cecaca' } }}
                >
                    <ArrowBackIosIcon style={{ color: '#8f7f7f', marginLeft: '6px' }} />
                </Button>
            </Box>

            <Container>
                <ScrollAnimation animateIn="fadeIn">
                    {LeadDetails === null || LeadDetails === '' ? null : (
                        <>
                            {LeadDetails?.status === 'appointment_set' || LeadDetails?.status === 'bamfam' ? (
                                <>
                                    <Box
                                        style={{
                                            marginTop: '20px',
                                            position: 'relative',
                                            borderRadius: '22px',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        }}
                                    >
                                        <div>
                                            <Box>
                                                <GoogleMap
                                                    onLoad={(map) => (mapRef.current = map)}
                                                    mapContainerStyle={mapContainerStyle}
                                                    options={{
                                                        disableDefaultUI: false,
                                                        clickableIcons: false,
                                                        scrollwheel: true,
                                                        mapTypeControl: false,
                                                        fullscreenControl: false,
                                                        streetViewControl: false,
                                                        minZoom: 1,
                                                    }}
                                                >
                                                    {destination?.lat && (
                                                        <OverlayView position={destination} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '10px',
                                                                    left: '55%',
                                                                    transform: 'translateX(-50%)',
                                                                    zIndex: 10,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    borderRadius: '4px',
                                                                    padding: '5px',
                                                                }}
                                                            >
                                                                <img
                                                                    src={PropertyIcon}
                                                                    style={{ width: '27px', height: '27px', marginTop: '-42px' }}
                                                                />
                                                            </div>
                                                        </OverlayView>
                                                    )}
                                                    {origin?.lat && (
                                                        <OverlayView position={origin} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '10px',
                                                                    left: '55%',
                                                                    transform: 'translateX(-50%)',
                                                                    zIndex: 10,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    borderRadius: '4px',
                                                                    padding: '5px',
                                                                }}
                                                            >
                                                                <img src={originMap} style={imageStyle} alt="Origin" />
                                                            </div>
                                                        </OverlayView>
                                                    )}
                                                    {origin2?.lat && (
                                                        <OverlayView position={origin2} mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '10px',
                                                                    left: '55%',
                                                                    transform: 'translateX(-50%)',
                                                                    zIndex: 10,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    borderRadius: '4px',
                                                                    padding: '5px',
                                                                }}
                                                            >
                                                                <img src={destinationMap} style={imageStyle2} alt="Origin" />
                                                            </div>
                                                        </OverlayView>
                                                    )}
                                                    {directions && (
                                                        <DirectionsRenderer
                                                            directions={directions}
                                                            options={{
                                                                suppressMarkers: true,
                                                                preserveViewport: true, // Prevent auto-zoom
                                                            }}
                                                        />
                                                    )}
                                                    {directions2 && (
                                                        <DirectionsRenderer
                                                            directions={directions2}
                                                            options={{
                                                                suppressMarkers: true,
                                                                preserveViewport: true, // Prevent auto-zoom
                                                            }}
                                                        />
                                                    )}
                                                </GoogleMap>
                                            </Box>
                                        </div>
                                    </Box>
                                    {distance === null && distance2 === null ? null : (
                                        <Card
                                            style={{
                                                padding: '20px',
                                                marginTop: '10px',
                                                borderRadius: '22px',
                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            }}
                                        >
                                            <Typography style={{ fontSize: '28px', fontWeight: '700' }}>Customer Details</Typography>
                                            <Divider />

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    justifyContent: 'space-around',
                                                    gap: '20px',
                                                    marginTop: '20px',
                                                }}
                                            >
                                                {/* Customer Section */}
                                                <Box>
                                                    <div style={{ display: 'grid' }}>
                                                        <Box style={{ marginTop: '10px' }}>
                                                            <Typography style={{ fontSize: '19px', fontWeight: '600', color: '#378b37' }}>
                                                                Customer
                                                            </Typography>
                                                        </Box>
                                                        <Box style={{ marginTop: '15px' }}>
                                                            <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Duration</Typography>
                                                            <Typography style={{ fontSize: '17px' }}>{duration}</Typography>
                                                        </Box>
                                                    </div>
                                                </Box>

                                                <Box>
                                                    <div style={{ display: 'grid' }}>
                                                        <Box style={{ marginTop: '10px' }}>
                                                            <Typography style={{ fontSize: '19px' }}>
                                                                {customerData?.name} {customerData?.last_name}
                                                            </Typography>
                                                        </Box>
                                                        <Box style={{ marginTop: '15px' }}>
                                                            <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Distance</Typography>
                                                            <Typography style={{ fontSize: '17px' }}>{distance}</Typography>
                                                        </Box>
                                                    </div>
                                                </Box>

                                                {/* Phone Number Section */}
                                                <Box style={{ marginTop: '15px' }}>
                                                    {phoneNumber1 ? (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span>{phoneNumber1}</span>
                                                        </div>
                                                    ) : (
                                                        <Button
                                                            style={{
                                                                width: 'auto',
                                                                height: '51px',
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                backgroundColor: '#F3F6FB',
                                                                border: '1px solid #e2e5ea',
                                                                textTransform: 'capitalize',
                                                            }}
                                                            endIcon={<PhoneIcon />}
                                                            onClick={handleButtonViewNumber1}
                                                        >
                                                            View Number
                                                        </Button>
                                                    )}
                                                </Box>

                                                {/* Agent Section */}
                                                <Box>
                                                    <div style={{ display: 'grid' }}>
                                                        <Box style={{ marginTop: '10px' }}>
                                                            <Typography style={{ fontSize: '19px', fontWeight: '600', color: '#1976d2' }}>
                                                                Agent
                                                            </Typography>
                                                        </Box>
                                                        <Box style={{ marginTop: '15px' }}>
                                                            <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Duration</Typography>
                                                            <Typography style={{ fontSize: '17px' }}>{duration2}</Typography>
                                                        </Box>
                                                    </div>
                                                </Box>

                                                <Box>
                                                    <div style={{ display: 'grid' }}>
                                                        <Box style={{ marginTop: '10px' }}>
                                                            <Typography style={{ fontSize: '19px', color: '#000000CC' }}>
                                                                {assigntoData?.name} {assigntoData?.last_name}
                                                            </Typography>
                                                        </Box>
                                                        <Box style={{ marginTop: '15px' }}>
                                                            <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Distance</Typography>
                                                            <Typography style={{ fontSize: '17px' }}>{distance2}</Typography>
                                                        </Box>
                                                    </div>
                                                </Box>

                                                <Box style={{ marginTop: '15px' }}>
                                                    {phoneNumber2 ? (
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <span>{phoneNumber2}</span>
                                                        </div>
                                                    ) : (
                                                        <Button
                                                            style={{
                                                                width: 'auto',
                                                                height: '51px',
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                backgroundColor: '#F3F6FB',
                                                                border: '1px solid #e2e5ea',
                                                                textTransform: 'capitalize',
                                                            }}
                                                            endIcon={<PhoneIcon />}
                                                            onClick={handleButtonViewNumber2}
                                                        >
                                                            View Number
                                                        </Button>
                                                    )}
                                                </Box>
                                            </div>

                                            {/* Destination and Meeting Location Section */}
                                            <div
                                                style={{
                                                    display: 'grid',
                                                    flexWrap: 'wrap',
                                                    justifyContent: 'flex-start',
                                                    gap: '5px',
                                                    marginTop: '20px',
                                                    paddingLeft: '22px',
                                                }}
                                            >
                                                <Box style={{ padding: '0px' }}>
                                                    <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Meeting Location</Typography>
                                                    <Typography style={{ fontSize: '17px' }}>{jobData?.meeting_location}</Typography>
                                                </Box>
                                                {/* <Box style={{ padding: '0px' }}>
                                                    <Typography style={{ fontSize: '19px', fontWeight: '600' }}>Destination</Typography>
                                                    <Typography style={{ fontSize: '17px' }}>{jobData?.display_address}</Typography>
                                                </Box> */}
                                            </div>
                                        </Card>
                                    )}
                                </>
                            ) : (
                                <Box
                                    style={{
                                        marginTop: '20px',
                                        position: 'relative',
                                        borderRadius: '22px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    }}
                                >
                                    {LeadDetails?.buyer_longitude === null && LeadDetails?.buyer_latitude === null ? null : (
                                        <>
                                            <div>
                                                {/* google image */}
                                                <img
                                                    src={`https://maps.googleapis.com/maps/api/staticmap?zoom=10&size=561x190&maptype=roadmap&center=${LeadDetails?.buyer_latitude},${LeadDetails?.buyer_longitude}&key=AIzaSyC9saN_UXZFij-RjWWX9drQEQSZw5PaPcA`}
                                                    alt="Static map"
                                                    className={classes.googleApisImageStyle}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '199px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 10,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    borderRadius: '4px',
                                                    padding: '5px',
                                                }}
                                            >
                                                <img
                                                    src={logo_white}
                                                    alt=""
                                                    style={{ width: '44px', height: '44px', borderRadius: '24px', border: '1px solid gray' }}
                                                />
                                            </div>
                                        </>
                                    )}
                                </Box>
                            )}
                        </>
                    )}

                    <Box style={{ marginTop: '20px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={7} lg={7}>
                                <Item sx={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', height: '105%' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '15px' }}>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <Box>
                                                <Avatar alt={LeadDetails?.first_name} src={logo_between} sx={{ height: '103px', width: '103px' }} />
                                            </Box>

                                            <Box style={{ display: 'grid' }}>
                                                <Box>
                                                    <Typography
                                                        style={{
                                                            fontSize: '30px',
                                                            fontFamily: 'inherit',
                                                            fontWeight: 'bold',
                                                            display: 'flex',
                                                            justifyContent: 'flex-start',
                                                        }}
                                                    >
                                                        {' '}
                                                        {LeadDetails?.first_name} {LeadDetails?.last_name}
                                                    </Typography>
                                                </Box>

                                                <Box style={{ display: 'flex', gap: '1px' }}>
                                                    <div>
                                                        <Typography
                                                            style={{
                                                                fontSize: '18px',
                                                                color: '#252F46CC',
                                                                fontFamily: 'inherit',
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            Location:{' '}
                                                        </Typography>
                                                    </div>
                                                    <div>
                                                        <Typography style={{ fontSize: '17px', color: '#252F46CC', fontFamily: 'inherit' }}>
                                                            {LeadDetails?.display_address}
                                                        </Typography>
                                                    </div>
                                                </Box>
                                                <Box style={{ display: 'flex', gap: '1px' }}>
                                                    <div>
                                                        <Typography
                                                            style={{
                                                                fontSize: '18px',
                                                                color: '#252F46CC',
                                                                fontFamily: 'inherit',
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            Tag:{' '}
                                                        </Typography>
                                                    </div>
                                                    <div>
                                                        <Typography style={{ fontSize: '17px', color: '#252F46CC', fontFamily: 'inherit' }}>
                                                            {LeadDetails?.tag}
                                                        </Typography>
                                                    </div>
                                                </Box>

                                                <Box style={{ display: 'flex', gap: '1px' }}>
                                                    <div>
                                                        <Typography
                                                            style={{
                                                                fontSize: '18px',
                                                                color: '#252F46CC',
                                                                fontFamily: 'inherit',
                                                                fontWeight: 'bold',
                                                            }}
                                                        >
                                                            Date & Time:{' '}
                                                        </Typography>
                                                    </div>
                                                    <div>
                                                        <Typography style={{ fontSize: '17px', color: '#252F46CC', fontFamily: 'inherit' }}>
                                                            {formattedDate}
                                                        </Typography>
                                                    </div>
                                                </Box>

                                                <Box style={{ display: 'flex', gap: '8px' }}>
                                                    <div>
                                                        <Button
                                                            style={{
                                                                width: 'auto',
                                                                height: '35px',
                                                                border: '1px solid #587DBF',
                                                                background: 'white',
                                                                color: '#587DBF',
                                                                borderRadius: '8px',
                                                            }}
                                                        >
                                                            {LeadDetails?.lead_type}
                                                        </Button>
                                                    </div>
                                                    <div>
                                                        <Button
                                                            style={{
                                                                width: 'auto',
                                                                height: '35px',
                                                                border: '1px solid #587DBF',
                                                                background: 'white',
                                                                color: '#587DBF',
                                                                borderRadius: '8px',
                                                            }}
                                                        >
                                                            {LeadDetails?.source}
                                                        </Button>
                                                    </div>
                                                </Box>
                                            </Box>
                                        </div>

                                        <div style={{ display: 'grid', gap: '30px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                                <div
                                                    style={{
                                                        ...divStyle,
                                                        borderRadius: '10px',
                                                        padding: '3px',
                                                        width: 'auto',
                                                        display: 'flex',
                                                        gap: '2px',
                                                        marginRight: LeadDetails?.buyer_max_price === null ? '25px' : '-14px',
                                                        height: '35px',
                                                    }}
                                                >
                                                    <div style={{ marginTop: '3px', cursor: 'pointer' }}>{formattedStatus}</div>
                                                </div>
                                            </div>
                                            {LeadDetails?.buyer_max_price == null ? null : (
                                                <div style={{ display: 'grid', justifyContent: 'center' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <Typography style={{ fontSize: '20px', color: '#252F46CC', fontWeight: 'bold' }}>
                                                            Price
                                                        </Typography>
                                                    </div>
                                                    <div>
                                                        <Typography style={{ color: '#252F46', fontSize: '38px', fontWeight: '700' }}>
                                                            {' '}
                                                            {formatCurrency(LeadDetails?.buyer_max_price)}
                                                        </Typography>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Box>
                                </Item>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5} lg={5}>
                                <Item
                                    sx={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', height: '105%', padding: '15px' }}
                                >
                                    <ScrollAnimation animateIn="fadeIn">
                                        <div>
                                            {LeadDetails?.assign === '0' ? null : (
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Box style={{ display: 'grid', gap: '10px' }}>
                                                        <Typography style={{ fontSize: '30px', fontWeight: '700', color: '#252F46' }}>
                                                            Communication
                                                        </Typography>
                                                        <Typography
                                                            style={{
                                                                fontSize: '12px',
                                                                fontWeight: '700',
                                                                color: '#726b6b',
                                                                fontFamily: 'inherit',
                                                                display: 'flex',
                                                            }}
                                                        >
                                                            Participants:
                                                        </Typography>
                                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                                            <Box>
                                                                <Avatar
                                                                    alt="AI"
                                                                    src={`https://iconnctapp.com/` + LeadDetails?.assignby?.profile_image}
                                                                />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>{LeadDetails?.assignby?.name}</Box>
                                                        </Box>

                                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                                            <Box>
                                                                <Avatar src={`https://iconnctapp.com/` + LeadDetails?.assignto?.profile_image} />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>{LeadDetails?.assignto?.name}</Box>
                                                        </Box>

                                                        <Box style={{ display: 'flex', gap: '10px' }}>
                                                            <Box>
                                                                <Avatar alt="Remy Sharp" src={logo_between} />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>
                                                                {LeadDetails?.first_name} {LeadDetails?.last_name}
                                                            </Box>
                                                        </Box>
                                                    </Box>

                                                    {/* chat section */}
                                                    {LeadDetails === null ? null : (
                                                        <Box
                                                            style={{
                                                                marginTop: '8px',
                                                                transform: 'scale(1)',
                                                                transition: 'transform 0.3s ease-in-out',
                                                            }}
                                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                                        >
                                                            <Box>
                                                                <MessageIcon
                                                                    onClick={() => navigate(`/admin-chat`, { state: { id: LeadDetails?.id } })}
                                                                    style={{ fontSize: '150px', cursor: 'pointer' }}
                                                                />
                                                            </Box>
                                                            <Box>
                                                                <Typography
                                                                    style={{
                                                                        fontSize: '20px',
                                                                        color: '#374971',
                                                                        fontWeight: 'bold',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    View Chat
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </ScrollAnimation>
                                </Item>
                            </Grid>
                        </Grid>
                        <>
                            <Grid container spacing={2} style={{ marginTop: '10px' }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <ScrollAnimation animateIn="fadeIn">
                                        <div style={{ marginTop: '20px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                                            {LeadDetails?.assign === '0' ? null : (
                                                <Card
                                                    sx={{
                                                        width: 'auto',
                                                        height: 'auto',
                                                        background: 'linear-gradient(#26c7f3, #316ec1)',
                                                        borderRadius: '22px',
                                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                    }}
                                                >
                                                    <CardContent>
                                                        <Box style={{ padding: '10px', display: 'flex', justifyContent: 'space-between' }}>
                                                            <Box>
                                                                <Typography style={{ fontSize: '30px', fontWeight: '700', color: 'white' }}>
                                                                    Assignment
                                                                </Typography>
                                                                <Box style={{ display: 'flex', marginBottom: '10px', marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '18px', fontWeight: 'bold', color: 'white' }}>
                                                                        Assign To:
                                                                    </Typography>
                                                                    <Typography style={{ fontSize: '18px', fontWeight: '500', color: 'white' }}>
                                                                        {' '}
                                                                        {LeadDetails?.assignto?.name} {LeadDetails?.assignto?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                                <Box style={{ display: 'flex' }}>
                                                                    <Typography style={{ fontSize: '18px', fontWeight: 'bold', color: 'white' }}>
                                                                        Assign By:
                                                                    </Typography>
                                                                    <Typography style={{ fontSize: '18px', fontWeight: '500', color: 'white' }}>
                                                                        {' '}
                                                                        {LeadDetails?.assignby?.name} {LeadDetails?.assignby?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            <Box>
                                                                <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                                    <Avatar
                                                                        alt={LeadDetails?.assignto?.profile_image}
                                                                        src={`https://iconnctapp.com/` + LeadDetails?.assignto?.profile_image}
                                                                        sx={{ mr: 6, width: 60, height: 60 }}
                                                                    />
                                                                </Box>
                                                                {LeadDetails?.time === null && LeadDetails?.date === null ? null : (
                                                                    <Box style={{ marginTop: '20px' }}>
                                                                        <Box>
                                                                            <Typography
                                                                                style={{ fontSize: '18px', fontWeight: '500', color: 'white' }}
                                                                            >
                                                                                <span style={{ fontWeight: 'bold' }}>Date & Time:</span>
                                                                                {formattedDateLeads}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                )}
                                                            </Box>
                                                        </Box>
                                                    </CardContent>
                                                </Card>
                                            )}
                                        </div>
                                    </ScrollAnimation>
                                </Grid>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    {/* chat module */}
                                    <ScrollAnimation animateIn="fadeIn">
                                        <div
                                            style={{
                                                display: 'grid',
                                                marginTop: '20px',
                                                borderRadius: '22px',
                                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            }}
                                        >
                                            <div>
                                                <Card
                                                    style={{
                                                        width: 'auto',
                                                        minHeight: '200px',
                                                        maxHeight: '500px',
                                                        background: 'rgb(207 227 244)',
                                                        border: '3px solid #192ea669',
                                                        borderRadius: '22px',
                                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                                        padding: '3px',
                                                        overflow: 'auto',
                                                    }}
                                                >
                                                    <CardContent>
                                                        <div style={{ marginBottom: '10px', display: 'flex', gap: '4px', fontSize: '30px' }}>
                                                            <div>
                                                                <NoteAltIcon style={{ fontSize: '30px' }} />
                                                            </div>
                                                            <span style={{ color: '#606060', fontWeight: 'bold', marginTop: '-4px' }}>Notes</span>
                                                        </div>

                                                        {displayNotes?.map((note, index) => {
                                                            // Ensure createTime exists and is valid before processing
                                                            if (note.createTime) {
                                                                // Split the createTime string into date and time components
                                                                const [datePart, timePart] = note.createTime.split('T');

                                                                // Extract year, month, and day from the date part
                                                                const [year, month, day] = datePart.split('-');

                                                                // Extract hour and minute from the time part
                                                                const [hour, minute] = timePart.substring(0, 5).split(':');

                                                                // Format date and time
                                                                const formattedDate = `${day}-${month}-${year}`;
                                                                const formattedTime = `${hour}:${minute}`;

                                                                // Combine date and time into desired format
                                                                const formattedCreateTime = `${formattedDate}  ${formattedTime}`;
                                                                const repliesToShow = showAllReplies ? note?.replies : note?.replies?.slice(0, 1);
                                                                return (
                                                                    <div
                                                                        key={note.id ?? index}
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            display: 'grid',
                                                                            // gridTemplateColumns: '1fr auto',
                                                                            alignItems: 'center',
                                                                            background: 'white',
                                                                            borderRadius: '10px',
                                                                            padding: '10px',
                                                                        }}
                                                                    >
                                                                        <div>
                                                                            <div style={{ color: '#000000b0', fontWeight: 'bold' }}>
                                                                                {note?.creatorName}
                                                                            </div>
                                                                            <div style={{ color: '#726b6b', gridColumn: '1 / span 2' }}>
                                                                                {note?.content}
                                                                            </div>
                                                                            <div style={{ color: '#726b6b', textAlign: 'right' }}>
                                                                                {formattedCreateTime}
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            {/* Display Replies */}
                                                                            {note?.replies?.length > 0 && (
                                                                                <div style={{ marginTop: '10px' }}>
                                                                                    <span
                                                                                        style={{
                                                                                            marginTop: '5px',
                                                                                            color: '#007BFF',
                                                                                            background: 'none',
                                                                                            cursor: 'pointer',
                                                                                            fontSize: '14px',
                                                                                            fontWeight: 'bold',
                                                                                        }}
                                                                                    >
                                                                                        Replies
                                                                                    </span>
                                                                                    {repliesToShow?.map((reply, replyIndex) => {
                                                                                        const [replyDatePart, replyTimePart] =
                                                                                            reply.created_at.split('T');
                                                                                        const [replyYear, replyMonth, replyDay] =
                                                                                            replyDatePart.split('-');
                                                                                        const [replyHour, replyMinute] = replyTimePart
                                                                                            .substring(0, 5)
                                                                                            .split(':');
                                                                                        const formattedReplyTime = `${replyDay}-${replyMonth}-${replyYear} ${replyHour}:${replyMinute}`;
                                                                                        return (
                                                                                            <div
                                                                                                key={reply?.id ?? replyIndex}
                                                                                                style={{ marginTop: '5px' }}
                                                                                            >
                                                                                                <div style={{ fontWeight: 'bold', color: '#444' }}>
                                                                                                    {reply.creatorName}
                                                                                                </div>
                                                                                                <div style={{ color: '#555' }}>{reply.reply}</div>
                                                                                                <div style={{ fontSize: '12px', color: '#888' }}>
                                                                                                    {formattedReplyTime}
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                                    {/* Show More / Show Less Button */}
                                                                                    {note?.replies?.length > 1 && (
                                                                                        <button
                                                                                            onClick={() => setShowAllReplies(!showAllReplies)}
                                                                                            style={{
                                                                                                marginTop: '5px',
                                                                                                color: '#007BFF',
                                                                                                background: 'none',
                                                                                                border: 'none',
                                                                                                cursor: 'pointer',
                                                                                                fontSize: '14px',
                                                                                                padding: '0',
                                                                                            }}
                                                                                        >
                                                                                            {showAllReplies ? 'Show Less' : 'Show More'}
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            } else {
                                                                // Handle the case where createTime is undefined or invalid
                                                                return (
                                                                    <div
                                                                        key={note.id ?? index}
                                                                        style={{
                                                                            marginBottom: '10px',
                                                                            display: 'grid',
                                                                            gridTemplateColumns: '1fr auto',
                                                                            alignItems: 'center',
                                                                            background: 'white',
                                                                            borderRadius: '10px',
                                                                            padding: '10px',
                                                                        }}
                                                                    >
                                                                        <div style={{ color: '#000000b0', fontWeight: 'bold' }}>
                                                                            {note?.creatorName}
                                                                        </div>
                                                                        <div style={{ color: '#726b6b', gridColumn: '1 / span 2' }}>
                                                                            {note?.content}
                                                                        </div>
                                                                        {/* <div style={{ color: '#726b6b', textAlign: 'right' }}>Invalid Date/Time</div> */}
                                                                    </div>
                                                                );
                                                            }
                                                        })}
                                                    </CardContent>
                                                </Card>
                                            </div>
                                        </div>
                                    </ScrollAnimation>
                                </Grid>
                            </Grid>
                        </>
                    </Box>
                </ScrollAnimation>
            </Container>
        </>
    ) : (
        <></>
    );
};

export default AdminLeadsDetails;
